import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { Contract } from '../../model/contract';
import { DwellingService } from '../data/dwelling.service';
import { Observable } from 'rxjs';

@Injectable()
export class DwellingExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: DwellingService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof FilteredCommand) {
      return command.id === rentalObjectCommand.export && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof FilteredCommand) {
      return this._dataService
        .export(command.filterProvider.filterState, command.includedIds, command.excludedIds, command.totalAffectedItemsControlValue)
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
          })
        );
    }
  }
}
